module.exports = __webpack_public_path__ + "static/media/pharmig.e84a7f85.png";